var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIntercourse = function SvgIntercourse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "46px",
    viewBox: "0 0 50 46",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group 11")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Timed-Intercourse",
    transform: "translate(-248.000000, -246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(248.000000, 246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    fill: "#C6C7CE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bracket/blank/gray"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4914768,0.694713468 L34.3582414,0 L30.8973285,4.91960512 L32.2141844,5.73061694 C39.0196566,9.91981914 42.9229554,16.2128525 42.9229554,22.9950773 C42.9229554,29.7969929 39.0396548,36.0894109 32.2669071,40.2607684 L30.9682315,41.0594735 L34.3430912,46 L35.4914768,45.2954412 C41.6854867,41.4945155 49.0666667,34.5406121 49.0666667,22.9950773 C49.0666667,11.4501578 41.6854867,4.49563915 35.4914768,0.694713468 L35.4914768,0.694713468 Z M16.8518763,5.73061694 C10.0470101,9.92043448 6.14310522,16.2134678 6.14310522,22.9950773 C6.14310522,29.7969929 10.0270118,36.0894109 16.8009716,40.260153 L18.0996472,41.0594735 L14.7235754,45.9993847 L13.5770079,45.2960565 C7.38360402,41.4957462 0,34.5412275 0,22.9950773 C0,11.4501578 7.382392,4.49563915 13.5751899,0.694713468 L14.7084252,0 L18.1699441,4.91960512 L16.8518763,5.73061694 Z",
    id: "Fill-1-Copy"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(15.000000, 15.000000)",
    fill: "#F8D0C5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,5.2092 L20,6.1032 C19.986,6.1632 19.97,6.2252 19.96,6.2872 C19.8342,7.2652 19.516,8.2086 19.024,9.0632 C18.609,9.7434 18.1324,10.3842 17.6,10.9772 C16.9172,11.76 16.1822,12.4958 15.4,13.1792 C14.682,13.8032 13.952,14.4152 13.2,14.9792 C12.2,15.7312 11.16,16.4372 10.14,17.1672 C10.0704,17.229 9.9656,17.229 9.896,17.1672 C8.998,16.5352 8.076,15.9312 7.202,15.2652 C6.282,14.5632 5.402,13.8212 4.514,13.0652 C3.3968,12.1148 2.3904,11.0414 1.514,9.8652 C0.8488,8.9764 0.3872,7.9522 0.162,6.8652 C0.092,6.6092 0.046,6.3752 0,6.1312 L0,5.2092 C0.012,5.1572 0.022,5.1072 0.034,5.0552 C0.122,4.6552 0.178,4.2552 0.304,3.8552 C0.726,2.5316 1.6374,1.4192 2.852,0.7452 C3.9826,0.085 5.3126,-0.147 6.6,0.0912 C7.8556,0.2986 9.0006,0.9346 9.84,1.8912 C9.8812,1.9476 9.9166,2.0078 9.946,2.0712 C10.164,1.8532 10.326,1.6852 10.496,1.5272 C12.6514,-0.4868 15.9952,-0.4982 18.164,1.5012 C18.9768,2.2394 19.5512,3.2032 19.814,4.2692 C19.902,4.5752 19.942,4.8912 20,5.2092",
    id: "Fill-1"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIntercourse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/intercourse.65a77633.svg";
export { ForwardRef as ReactComponent };